/**
 * Comics API endpoints.
 *
 * Follows the same pattern as api/tracks.js — thin wrappers around
 * the shared api client's get/post/patch/del methods.
 */

import { api } from './client.js';

// ── Public ──

export const getComicsHome = () => api.get('/api/comics');
export const getCurrentComic = () => api.get('/api/comics/current');
export const getComic = (id) => api.get(`/api/comics/${id}`);

// ── Reactions ──

export const getComicReactions = (id) => api.get(`/api/comics/${id}/reactions`);
export const reactToComic = (id, emoji) =>
  api.post(`/api/comics/${id}/reactions`, { emoji });

// ── Comments ──

export const listComicComments = (comicId) => api.get(`/api/comics/${comicId}/comments`);
export const createComicComment = (comicId, body) =>
  api.post(`/api/comics/${comicId}/comments`, { body });

// Edit and delete use the shared /api/comments/:id endpoints (same as tracks)
// so import updateComment and deleteComment from tracks.js

// ── Admin ──

export const getAdminComics = () => api.get('/api/comics/admin');

export const uploadComic = (formData) =>
  api.post('/api/comics', formData);

export const updateComic = (id, data) => api.patch(`/api/comics/${id}`, data);
export const setCurrentComic = (id) => api.post(`/api/comics/${id}/set-current`);
export const deleteComic = (id, hard = false) =>
  api.del(`/api/comics/${id}${hard ? '?hard=true' : ''}`);
